import { IIconProps } from "../types"

export default function IconUL3(props: IIconProps) {
  const width = props.size || props.width || (84 / 5) * 3
  const height = props.size || props.height || (124 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 84 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.8772 1.03078C49.1984 0.520945 45.5495 0.211044 42.6305 0.680894C39.7214 1.15074 37.5221 2.41034 35.4828 3.79989C33.4534 5.17945 31.594 6.67897 28.1251 12.0772C24.6562 17.4855 19.5779 26.7925 15.0493 35.8696C10.5208 44.9467 6.55204 53.7739 4.06284 60.6817C1.58363 67.5894 0.583951 72.5578 0.46399 76.0667C0.334031 79.5756 1.07379 81.6349 2.20343 84.3141C3.33307 86.9932 4.85258 90.3122 8.15153 95.1606C11.4505 100.019 16.5288 106.407 20.8075 111.175C25.0761 115.954 28.545 119.113 31.634 120.882C34.723 122.662 37.4321 123.052 40.6911 122.702C43.95 122.342 47.7588 121.242 53.467 118.553C59.1752 115.874 66.7927 111.615 71.5712 108.496C76.3597 105.377 78.299 103.408 79.7786 100.689C81.2681 97.9597 82.2778 94.4908 82.7476 90.1922C83.2075 85.8936 83.1275 80.7652 82.5377 74.4572C81.9379 68.1393 80.8382 60.6417 78.6389 50.6649C76.4396 40.6881 73.1407 28.2121 70.5215 19.8547C67.8924 11.4874 65.953 7.22879 63.1139 4.73959C60.2748 2.26039 56.556 1.55061 52.8772 1.03078Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
